import { useEffect } from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { EditableContent } from "../components/EditableContent";

export default function ContentPage({ file, title, heading, subtitle }) {
  useEffect(() => { document.title = `${title} | Tenverly`; }, [title]);
  return (
    <div className="App bg-[#F4F7FA] min-h-screen">
      <Navbar />
      <section className="bg-navy text-white">
        <div className="max-w-4xl mx-auto px-5 py-14 text-center">
          <h1 className="font-heading font-extrabold text-4xl md:text-5xl">{heading}</h1>
          {subtitle && <p className="mt-3 text-slate-300 text-lg">{subtitle}</p>}
        </div>
      </section>
      <div className="max-w-3xl mx-auto px-5 py-12">
        <article className="tenverly-content bg-white rounded-2xl border border-slate-200 p-8 shadow-sm">
          <EditableContent file={file} />
        </article>
      </div>
      <Footer />
    </div>
  );
}
